import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {HTH} from "../HTH";
import {gsap} from "gsap";
import {HTHHelper} from "../utils/HTHHelper";
import {HTHGameMode} from "../server/HTHGameMode";
import {HTHSound} from "../sound/HTHSound";
import {HTHSafeSymbol} from "../symbols/HTHSafeSymbol";

export class ExtraSpinView extends PIXI.Container implements StageLayer {

    private _promptArea: PIXI.Sprite;
    private _rtpBox: PIXI.Sprite;
    private _buyText1: PIXI.Text;
    private _yesBtn: ContinueButton;
    private _noBtn: ContinueButton;
    private _anticipationTl: gsap.core.Timeline | null;
    private _sendZeroBet: boolean = false;

    private clickCallback?: Function;


    constructor() {
        super();
        this.init();
        this.name = "ExtraSpinView";
    }

    public enablePromptArea(cb: Function): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline({delay: 0.1});

        this._sendZeroBet = false;
        tl.add(() => {
            this.visible = true;
            HTH.keypadPlugin.setZeroBetSpinCounter(-1);
            this._buyText1.text = HTH.apiPlugin.translations.translate("Buy Extra Spin For EXTRA_SPIN_VALUE (deducted from your win)?").replace("EXTRA_SPIN_VALUE", HTH.apiPlugin.currency.format(HTH.model.data.extraSpinCost ? HTH.model.data.extraSpinCost : ""));
        }, 0);
        tl.to(this, {duration: 0.2, alpha: 1}, '<');
        tl.add(() => {
            this.clickCallback = cb;
            this._yesBtn.enable(true);
            this._noBtn.enable(true);
        }, ">");
        if (HTH.gameViewContainer.scatterCollector.scatterCount % 3 === 2) {
            tl.add(this.playAnticipation());
        }

        return tl;

    }

    public handleReplay(cb: Function): void {
        const tl: gsap.core.Timeline = gsap.timeline({delay: 0.1});

        const selectedOption: string = HTH.model.data.nextPlayerInteraction.playExtraSpin === "yes" ? "YES" : "NO";
        tl.add(() => {
            this.visible = true;
            this.clickCallback = cb;
            this._yesBtn.enable(false);
            this._noBtn.enable(false);
            HTH.keypadPlugin.setZeroBetSpinCounter(-1);

            this._buyText1.text = HTH.apiPlugin.translations.translate("Buy Extra Spin For EXTRA_SPIN_VALUE (deducted from your win)?").replace("EXTRA_SPIN_VALUE", HTH.apiPlugin.currency.format(HTH.model.data.extraSpinCost ? HTH.model.data.extraSpinCost : ""));
        }, 0);

        tl.to(this, {duration: 0.2, alpha: 1}, '<')


        tl.to(this, {duration: 0.5});

        if (selectedOption === "YES") {
            tl.to(this._yesBtn.scale, {x: 0.8, y: 0.8, duration: 0.2});
            tl.to(this._yesBtn.scale, {x: 1, y: 1, duration: 0.2});
        } else {
            tl.to(this._noBtn.scale, {x: 0.8, y: 0.8, duration: 0.2});
            tl.to(this._noBtn.scale, {x: 1, y: 1, duration: 0.2});
        }

        tl.to(this, {duration: 0.2, alpha: 0}, '<')

        tl.add(() => {
            HTH.apiPlugin.betHandler.zeroBet({playUpgradeBet: selectedOption});
            if (selectedOption == "YES") {
                const newWinAmount = HTH.model.data.accumulatedRoundWin - (HTH.model.data.extraSpinCost ? HTH.model.data.extraSpinCost : 0);
                HTH.keypadPlugin.setWin(newWinAmount, true, HTHHelper.isWinBelowStakeCurrentBet(newWinAmount));
            }
            if (HTH.model.nextMode === HTHGameMode.NORMAL) {
                HTHSound.switchMusic({name: HTHSound.MAIN_GAME_MUSIC});
            } else if (HTH.model.mode === HTHGameMode.FREESPIN) {
                HTHSound.playSFSMusic(HTH.model.safeSymbols);
            }
            this.visible = false;
            if (this.clickCallback == undefined) {
                throw new Error("No button click callback");
            }
            this.clickCallback();
        });

    }

    private init() {
        this._promptArea = new PIXI.Sprite(HTH.assetLoader.getTextures("Extra_Spin_Screen")[0]);
        this._promptArea.anchor.set(0.5, 0.5);
        this._promptArea.position.set(360, 378);
        this._promptArea.scale.set(1.2, 1.2);
        this._promptArea.alpha = 0.75;
        this._promptArea.name = "promptArea"

        this._rtpBox = new PIXI.Sprite(HTH.assetLoader.getTextures("RTP_sign")[0]);
        this._rtpBox.anchor.set(0.5, 0.5);
        this._rtpBox.position.set(602, 179);
        this._rtpBox.alpha = 1;
        this._rtpBox.name = "rtpBox";
        this.addChild(this._promptArea, this._rtpBox);


        this._buyText1 = new PIXI.Text(HTH.apiPlugin.translations.translate("Buy Extra Spin For EXTRA_SPIN_VALUE (deducted from your win)?").replace("EXTRA_SPIN_VALUE", HTH.apiPlugin.currency.format(HTH.model.data.extraSpinCost ? HTH.model.data.extraSpinCost : "")), {
            dropShadow: true,
            dropShadowAlpha: 0.6,
            dropShadowAngle: 1.4,
            dropShadowBlur: 3,
            dropShadowDistance: 1,
            fill: 0xffffff,
            fontFamily: "Arial Black",
            fontSize: 33,
            lineJoin: "round",
            stroke: 0x261712,
            strokeThickness: 10,
            wordWrapWidth: 600,
            wordWrap: true,
            breakWords: true,
        })

        this._buyText1.anchor.set(0.5, 0.5);
        this.addChild(this._buyText1);
        this._buyText1.position.set(363, 407);
        this._buyText1.scale.set(1, 1.5);
        this._buyText1.name = "buyText"

        this._yesBtn = new ContinueButton(HTH.apiPlugin.translations.translate("YES"));
        this._yesBtn.setSize(240, 140);
        this._yesBtn.addClickCallback(() => this.clickedYes());

        this._yesBtn.position.set(185, 572);
        this._yesBtn.pivot.set(this._yesBtn.width * 0.5, this._yesBtn.height * 0.5);
        this._yesBtn.enable(false);

        this._noBtn = new ContinueButton(HTH.apiPlugin.translations.translate("NO"));
        this._noBtn.setSize(240, 140);
        this._noBtn.addClickCallback(() => this.clickedNo());
        this._noBtn.position.set(530, 572);
        this._noBtn.pivot.set(this._noBtn.width * 0.5, this._noBtn.height * 0.5);
        this._noBtn.enable(false);
        this.alpha = 0;
        this.visible = false;
        this.addChild(this._noBtn);
        this.addChild(this._yesBtn);

    }

    private clickedYes(): void {
        const tl: gsap.core.Timeline = gsap.timeline();
        if (this._anticipationTl) {
            this._anticipationTl.kill();
            this._anticipationTl = null;
            HTH.gameViewContainer.scatterCollector.resetScatterCollectorSize();
            HTH.model.data.safeSymbols.forEach((pos) => {
                const sym: HTHSafeSymbol = <HTHSafeSymbol>HTH.reelArea.getSymbol([pos.x, pos.y]);
                sym.resetMultiSize();
            })
        }
        this._noBtn.enable(false);
        this._yesBtn.enable(false);
        HTHSound.playTrack(HTHSound.CONTINUE_BUTTON);
        if (!this._sendZeroBet) {
            this._sendZeroBet = true;
            tl.to(this, {duration: 0.15, alpha: 0}, 0);
            tl.add(() => {
                const newWinAmount = HTH.model.data.accumulatedRoundWin - (HTH.model.data.extraSpinCost ? HTH.model.data.extraSpinCost : 0);
                HTH.keypadPlugin.setWin(newWinAmount, true, HTHHelper.isWinBelowStakeCurrentBet(newWinAmount));
                HTH.apiPlugin.betHandler.zeroBet({playExtraSpin: "yes"});
                HTHSound.playSFSMusic(HTH.model.safeSymbols);
                this.visible = false;

                if (this.clickCallback == undefined) {
                    throw new Error("No button click callback");
                }
                this.clickCallback();

            }, ">");
        }

    }

    private clickedNo(): void {
        const tl: gsap.core.Timeline = gsap.timeline();
        if (this._anticipationTl) {
            this._anticipationTl.kill();
            this._anticipationTl = null;
            HTH.gameViewContainer.scatterCollector.resetScatterCollectorSize();
            HTH.model.data.safeSymbols.forEach((pos) => {
                const sym: HTHSafeSymbol = <HTHSafeSymbol>HTH.reelArea.getSymbol([pos.x, pos.y]);
                sym.resetMultiSize();
            })
        }
        this._noBtn.enable(false);
        this._yesBtn.enable(false);
        HTHSound.playTrack(HTHSound.CONTINUE_BUTTON);
        tl.add(HTH.gameViewContainer.scatterCollector.showScatterCollector(false), 0);
        if (!this._sendZeroBet) {
            this._sendZeroBet = true;
            tl.add(() => {
                HTH.apiPlugin.betHandler.zeroBet({playExtraSpin: "no"});
                if (this.clickCallback == undefined) {
                    throw new Error("No button click callback");
                }
                this.clickCallback();
            }, 0);
            tl.to(this, {duration: 0.2, alpha: 0}, 0);
            tl.add(() => {
                HTHSound.switchMusic({name: HTHSound.MAIN_GAME_MUSIC});
                HTH.backgroundElements.setMode(HTHGameMode.NORMAL);
                this.visible = false;
            }, ">");
        }

        // if (!HTHHelper.isWinBelowStake()) {
        //     tl.add(HTH.totalWinView.showInExtraSpin(HTHWinConfig.getWinConfig(HTH.model.data.spinWin/HTH.model.gameData?.playedBetValue)));
        // }

    }

    private playAnticipation(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline({repeat: -1});

        tl.add(HTH.gameViewContainer.scatterCollector.playPumpAnimation());
        HTH.model.data.safeSymbols.forEach((pos) => {
            const sym: HTHSafeSymbol = <HTHSafeSymbol>HTH.reelArea.getSymbol([pos.x, pos.y]);
            tl.add(sym.playMultiPumpAnim(), 0);
        })

        this._anticipationTl = tl;
        return tl;
    }
}